import { LANGUAGES } from './LANGUAGE';

/**
 * Default language to use for translation.
 * @type {string} - The default language.
 */
export const DEFAULT_LANGUAGE = LANGUAGES.ES;

/**
 * Default value for the AI switch.
 * @type {boolean} - The default value for the AI switch.
 */
export const SWITCH_AI_DEFAULT = false;

/**
 * @type {number} - Default per page elements.
 */
export const DEFAULT_PER_PAGE_ELEMENTS = 50;

/**
 * @type {number} - Default zoom value.
 */
export const DEFAULT_ZOOM_VALUE = 100;

/**
 * @type {boolean} - Default value for open links in new tab.
 */
export const DEFAULT_OPEN_LINKS = false;

/**
 * @type {number} - Default min height for the actives.
 */
export const MIN_ACTIVES_HEIGHT = 200;

/**
 * @type {number} - Default dark mode value.
 */
export const DEFAULT_DARK_MODE_VALUE = true;

/**
 * @type {boolean} - Default pagination value.
 */
export const DEFAULT_PAGINATION_VALUE = true;

/**
 * @type {number} - Default load previous pages.
 * @default 5
 */
export const DEFAULT_LOAD_PREVIOUS_PAGES = 5;

/**
 * @type {string} - Default type file.
 */
export const DEFAULT_TYPE_FILE = 'image/jpeg';
